import React, { memo, useMemo } from 'react'
import { Button } from '@mui/material'
import clsx from 'clsx'
import Image from 'next/image'
import CloseIcon from '@mui/icons-material/Close'
import sx from './styles'

const HybridVehicle = ({
  item, value, onChange, showCloseButton,
}) => {
  const handleFuelButtonClick = (current) => {
    onChange({ fuelType: value === current.slug ? '' : current.slug })
  }
  // Cambió el diseño de active y se ocultarions los iconos claros (active)
  const subfolder = useMemo(() => (value.includes(item?.slug) ? 'OnHold' : 'OnHold'), [value, item])

  return (
    <Button
      variant={value.includes(item?.slug) ? 'special' : 'secondary'}
      sx={sx.button}
      title={`Autos seminuevos ${item?.name}`}
      startIcon={(
        <Image
          src={`/img/vehicleTypes/${subfolder}/hibrido.svg`}
          alt={`Autos seminuevos ${item?.name}`}
          title={`Autos seminuevos ${item?.name}`}
          width={38}
          height={15}
        />
      )}
      className={clsx({
        selected: value.includes(item?.slug),
      })}
      size="small"
      onClick={() => handleFuelButtonClick(item)}
      endIcon={showCloseButton && <CloseIcon />}
    >
      {item?.name}
    </Button>
  )
}

export default memo(HybridVehicle)
